export default function ValueProposition() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-14">
          <div className="lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Why Choose Itaobuy Sheet?
            </h2>
          </div>
          <div className="lg:w-1/2">
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
              The <strong>itaobuy spreadsheet</strong> system transforms complex cross-border sourcing into a simple, organized workflow — giving you clarity and control at every step.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="rounded-2xl bg-background-50 p-6 md:p-8 border border-background-200/70">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
              <i className="ri-scales-line w-5 h-5 flex items-center justify-center text-primary-600"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
              Transparent Pricing
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              The itaobuy spreadsheet system displays clear, itemized cost breakdowns including product price, shipping, and service fees — no hidden charges, no surprises.
            </p>
          </div>

          <div className="rounded-2xl bg-background-50 p-6 md:p-8 border border-background-200/70">
            <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
              <i className="ri-flashlight-line w-5 h-5 flex items-center justify-center text-accent-600"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
              Fast Processing
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              With the structured itaobuy spreadsheet format, orders are processed significantly faster than traditional manual sourcing methods, reducing lead times dramatically.
            </p>
          </div>

          <div className="rounded-2xl bg-background-50 p-6 md:p-8 border border-background-200/70">
            <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mb-5">
              <i className="ri-global-line w-5 h-5 flex items-center justify-center text-secondary-600"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
              Global Shipping
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              The itaobuy spreadsheet system supports worldwide delivery with multiple shipping options, so buyers from any country can receive their sourced products reliably.
            </p>
          </div>
        </div>

        <div className="mt-12 rounded-2xl overflow-hidden border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Feature</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Itaobuy Spreadsheet</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Traditional Shopping</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-background-200/70">
                <td className="px-6 py-3.5 text-foreground-700">Product Visibility</td>
                <td className="px-6 py-3.5 text-accent-600 font-medium">High</td>
                <td className="px-6 py-3.5 text-foreground-500">Low</td>
              </tr>
              <tr className="border-t border-background-200/70 bg-background-50">
                <td className="px-6 py-3.5 text-foreground-700">Price Transparency</td>
                <td className="px-6 py-3.5 text-accent-600 font-medium">High</td>
                <td className="px-6 py-3.5 text-foreground-500">Medium</td>
              </tr>
              <tr className="border-t border-background-200/70">
                <td className="px-6 py-3.5 text-foreground-700">Ease of Use</td>
                <td className="px-6 py-3.5 text-accent-600 font-medium">Simple</td>
                <td className="px-6 py-3.5 text-foreground-500">Complex</td>
              </tr>
              <tr className="border-t border-background-200/70 bg-background-50">
                <td className="px-6 py-3.5 text-foreground-700">Time Efficiency</td>
                <td className="px-6 py-3.5 text-accent-600 font-medium">Fast</td>
                <td className="px-6 py-3.5 text-foreground-500">Slow</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}